import { gql } from '@apollo/client';

const typeDefs = gql`
  type Query {
    isMobile: Boolean!
    isAndroid: Boolean!
    isWebview: Boolean
    source: String
    user: Object
    abRandValue: String
  }
`;

export default typeDefs;
